// extracted by css-extract-rspack-plugin
export default {"selectedItemPrefix":"gTge6LkLuRgMCwbD","button":"p4GuqjUYoIEXDv9K","listFooter":"s7RqAUqTVtcaNFRG"};